export default function getGACookie() {
  function getCookie(name) {
    const matches = document.cookie.match(
      new RegExp(
        `(?:^|; )${name.replace(
          /([\.$?*|{}\(\)\[\]\\\/\+^])/g, // eslint-disable-line no-useless-escape
          '\\$1'
        )}=([^;]*)`
      )
    );
    return matches ? decodeURIComponent(matches[1]) : '';
  }

  const cidLong = getCookie('_ga'); // GA1.2.xxxxxxxx.yyyyyyyy
  if (cidLong) {
    const tmp = cidLong.split('.');
    return `${tmp[2]}.${tmp[3]}`;
  }
  return '';
}
